import { get, post } from './request'

export function loginApi(data) {
  return post('/api/user/login', data)
}

export function regApi(data) {
  return post('/api/user/reg', data)
}

export function regChannelApi(data) {
  return post('/api/agent/reg', data)
}

export function getCodeApi(data) {
  return post('/api/user/code', data)
}

export function changePasswordApi(data) {
  return post('/api/user/password', data)
}

export function orderApi(data) {
  return post('/api/card/order', data)
}

export function kycApi(data, options) {
  return post('/api/user/kyc', data, options)
}

export function getOrdersApi(params) {
  return get('/api/user/orders', params)
}

export function chargeApi(params) {
  return post('/api/card/charge', params)
}

export function getChargeListApi(params) {
  return get('/api/user/charges', params)
}

export function getUserInfoApi(params) {
  return get('/api/user/info', params)
}

export function getAllPlansApi(params) {
  return get('/api/plans', params)
}

export function getRebatesApi(params) {
  return get('/api/user/rebates', params)
}

export function addAgentApi(params) {
  return post('/api/agent/new', params)
}

export function channelSubmitApi(params) {
  return post('/api/user/update', params)
}

export function auditApi(params) {
  return post('/api/agent/audit', params)
}

export function getSubChannelApi(params) {
  return get('/api/user/invitees', params)
}

export function getSubPlansApi(params) {
  return get('/api/user/invitee/plans', params)
}

export function getInviteListApi(params) {
  return get('/api/user/invitees', params)
}

export function getAllCardApi(params) {
  return get('/api/user/cards', params)
}

export function getCardDetailApi(params) {
  return get('/api/user/card', params)
}

export function partnerApi(params, options) {
  return post('/api/agent/apply', params, options)
}

export function getApplyHistoryApi(params) {
  return get('/api/agent/applies', params)
}

export function getCanExpandApi(params) {
  return get('/api/agent/permissions', params)
}
